import React from 'react';
import Pagination from './Pagination';
import { LatestPostsListProps } from '../../helpers/interfaces';
import LatestPostsBase from './LatestPostsBase';

const LatestPostsComponent: React.FC<LatestPostsListProps> = ({
  heading = 'The latest from our experts',
  numberOfPages,
  currentPath,
  authId,
  toHideCategory,
  initPosts,
  currentPage,
  className,
  headingTagName
}) => {
  const HeadingTag = (headingTagName as keyof JSX.IntrinsicElements) || 'h2'; // Safe dynamic tag

  return (
    <section
      className={`${className || ''} container container-py`}
      id="latest-posts">
      {currentPage !== 1 ? (
        <div className="d-lg-flex heading-mb justify-content-between align-items-center">
          {React.createElement(HeadingTag, { className: 'mb-2 mb-lg-0' }, heading)}
          <p className="ms-lg-3 text-gray">Page {currentPage}</p>
        </div>
      ) : (
        React.createElement(HeadingTag, { className: 'heading-mb' }, heading)
      )}

      <div className="row gx-lg-6">
        <LatestPostsBase
          initPosts={initPosts}
          authId={authId}
          toHideCategory={toHideCategory}
        />
      </div>

      {numberOfPages > 1 && (
        <Pagination
          currentPage={currentPage || 1}
          numberOfPages={numberOfPages}
          className="mt-2"
          currentPath={currentPath}
        />
      )}
    </section>
  );
};

export default LatestPostsComponent;
